import FormattedMessage from 'I18n/components/FormattedMessage';
import { EllipsesIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultProps = {
  onClickHandler: () => {}
};
const ThreeDotIconButton = ({
  onClickHandler
}) => {
  return /*#__PURE__*/_jsx(IconButton, {
    marginBlockStart: "400",
    marginInlineEnd: "0",
    marginBlockEnd: "250",
    marginInlineStart: "0",
    paddingBlockStart: "200",
    shape: "circle",
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'conversations-thread-view.editors.previousMessageHistory.noEditsTooltip'
    }),
    size: "extra-small",
    onClick: onClickHandler,
    children: /*#__PURE__*/_jsx(EllipsesIcon, {
      size: "800"
    })
  });
};
ThreeDotIconButton.displayName = 'ThreeDotIconButton';
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
ThreeDotIconButton.defaultProps = defaultProps;
export default ThreeDotIconButton;